export default __webpack_public_path__ + "static/media/multiplayer_manual.39520847.docx";